export function getLockedStudentLessonRedirect(args: {
  lockedLes: { lesId: string; schoolSlug: string } | null;
  pathname: string;
  locale: string;
  schoolyear?: string;
}): {
  to: "/$locale/{-$schoolyear}/$school/lesson/$lesson/student";
  params: { locale: string; schoolyear?: string; school: string; lesson: string };
} | null {
  const { lockedLes } = args;
  if (!lockedLes) return null;

  const lockedLessonStudentPath = `/lesson/${lockedLes.lesId}/student`;
  const isAlreadyOnStudentLessonUrl =
    args.pathname.includes(`${lockedLessonStudentPath}/`) ||
    args.pathname.endsWith(lockedLessonStudentPath);

  if (isAlreadyOnStudentLessonUrl) return null;

  return {
    to: "/$locale/{-$schoolyear}/$school/lesson/$lesson/student",
    params: {
      locale: args.locale,
      schoolyear: args.schoolyear,
      school: lockedLes.schoolSlug,
      lesson: lockedLes.lesId,
    },
  };
}
